function initPdpCollectionSliders(root = document) {
  const sliders = root.querySelectorAll('[data-pdp-collection-slider]');

  sliders.forEach((slider) => {
    if (slider.swiper || typeof Swiper === 'undefined') return;

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      direction: 'horizontal',
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        1440: {
          spaceBetween: 16,
        },
      },
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPdpCollectionSliders());
} else {
  initPdpCollectionSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  initPdpCollectionSliders(event.target);
});
